export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11276_QUICK_ACCESS': 'Quick Access',
    '_11277_SEARCH_FOR_USER': 'Search for user'
};
